// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"a5f8c70e","163":"f852a840","180":"f985dc5d","704":"eb9dd31d","810":"6267440e","960":"77065505"}[chunkId] + ".chunk.js";
};